/**
 * Services do hub de Configurações (Fase C) — preferências de notificação (B1)
 * e sessões ativas (B2). Desembrulha o envelope `{data:...}` de forma defensiva
 * (funciona quer o `request` desembrulhe, quer não).
 */
function unwrap(resp) {
  return resp?.data ?? resp;
}

// ---- Notificações (B1) ----
export async function getPreferenciasNotificacao(request) {
  return unwrap(await request("/api/me/notificacoes-preferencias"));
}

export async function salvarPreferenciasNotificacao(request, dados) {
  return unwrap(
    await request("/api/me/notificacoes-preferencias", {
      method: "PUT",
      body: JSON.stringify(dados),
    })
  );
}

// ---- Sessões ativas (B2) ----
export async function getSessoes(request) {
  return unwrap(await request("/api/me/sessoes"));
}

export async function revogarSessao(request, sessaoId) {
  return unwrap(await request(`/api/me/sessoes/${sessaoId}`, { method: "DELETE" }));
}

export async function revogarOutrasSessoes(request) {
  return unwrap(await request("/api/me/sessoes/revogar-outras", { method: "POST" }));
}
